<template>
  <Modal ref="modalRef" info>
    <template #title>Something went wrong</template>
    <template #icon>
      <AlertTriangleIcon class="icon"/>
    </template>
    <p>Sorry, an unexpected error occurred.</p>
    <p v-if="messageRef" class="error-message">{{ messageRef }}</p>
    <template #okText>OK</template>
  </Modal>
</template>

<style lang="scss" scoped>
.icon {
  margin-right: 0.5rem;
  color: var(--bs-warning);
}

.error-message {
  font-size: 0.875rem;
  color: #888;
}
</style>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { AlertTriangleIcon } from '@zhuowenli/vue-feather-icons'
import Modal from './Modal.vue'
import { unexpectedErrorEvent } from './AppUtil'
import { useTelemetry } from './Telemetry'

const modalRef = ref<InstanceType<typeof Modal>>()
const messageRef = ref<string>()

const { trackException } = useTelemetry()

onMounted(() => {
  unexpectedErrorEvent.on(args => {
    if (args.error) {
      trackException(args.error)
    }
    messageRef.value = args.error instanceof Error ? args.error.message : undefined
    modalRef.value?.open()
  })
})
</script>
